module.exports = __webpack_public_path__ + "static/media/other-income.cdd5859e.svg";